import type {
    ExtendedLocalStorageKey,
    ExtendedLocalStorageValueMap,
    LocalStorageKey,
    LocalStorageValueMap,
} from '@core/app/types'

export function setLocalStorageItem<K extends ExtendedLocalStorageKey>(
    key: K,
    value: ExtendedLocalStorageValueMap[K]
): void {
    try {
        const serializedValue = JSON.stringify(value)
        localStorage.setItem(key, serializedValue)
    } catch (error) {
        console.error(`[LocalStorage] Failed to set item with key "${key}":`, error)
    }
}

export function getLocalStorageItem<K extends ExtendedLocalStorageKey>(
    key: K,
    defaultValue?: ExtendedLocalStorageValueMap[K]
): ExtendedLocalStorageValueMap[K] | null {
    try {
        const value = localStorage.getItem(key)
        if (value !== null) {
            return JSON.parse(value) as ExtendedLocalStorageValueMap[K]
        }
        return defaultValue ?? null
    } catch (error) {
        console.error(`[LocalStorage] Failed to get item with key "${key}":`, error)
        return defaultValue ?? null
    }
}

export function removeLocalStorageItem(...keys: ExtendedLocalStorageKey[]): void {
    keys.forEach((key) => {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            console.error(`[LocalStorage] Failed to remove key "${key}":`, error)
        }
    })
}
